export const importFromCsv = {
  title: 'CSV Import Detergent',
  importSuccessfully: 'Import detergents successfully!',
  importFailed: 'Import detergents failed!',
}
